
<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['ADDUSER'] | translate}}</h4>        
    </div>
    <div class="card-body">
        <form [formGroup]="userForm" novalidate>
            
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Email" formControlName="email" required>
                        <mat-error *ngIf="!userForm.controls['email'].valid && userForm.controls['email'].touched"> {{
                            getErrorEmail() }} </mat-error>
                    </mat-form-field>
                </div>
            </div>            

            <hr>
            <h5>Benutzer, dessen Rollen übernommen werden sollen:</h5>        
            <mat-slide-toggle  [disabled]="false" color="primary" (change)="onChange()">inkl. Mandantengruppenrollen</mat-slide-toggle> 

            <!-- <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill" >
                        <mat-label>{{this.translate.data['SELECTTENANTGROUPROLE'] | translate}}</mat-label>
                        <mat-select formControlName="userRoles" multiple>
                            <mat-option *ngFor="let role of groupRoles" [value]="role">
                                {{role.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!userForm.controls['userRoles'].valid && userForm.controls['userRoles'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div> -->

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width" *ngIf="!_userSelected">
                        <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="copyUser" [matAutocomplete]="auto">

                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                            (optionSelected)="optionSelected($event)">
                            <mat-option *ngIf="isLoading" class="is-loading">
                                <mat-spinner diameter="50"></mat-spinner>
                            </mat-option>
                            <ng-container *ngIf="!isLoading">
                                <mat-option *ngFor="let user of users" [value]="user">
                                    <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                    <!-- <a class="a-color" *ngIf="_userSelected && projectGroupRoleUser.userName != ''">{{projectGroupRoleUser.userName}}</a> -->
                    <a class="a-color" *ngIf="_userSelected && copyUserName != ''">{{copyUserName}}</a>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill" >
                        <mat-label>{{this.translate.data['SELECTUSERROLE'] | translate}}</mat-label>
                        <mat-select formControlName="userRoles" multiple>
                            <mat-option *ngFor="let role of groupRoles" [value]="role">
                                {{role.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!userForm.controls['userRoles'].valid && userForm.controls['userRoles'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div> -->

            <div class="row">
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                </a>                                                
                <span style="flex: 1 1 auto"></span>
                <a>
                        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPADDUSERDIALOG'] | translate}}"
                                        (click)="add()" >Hinzufügen</button>
                </a>                   
    
            </div>    
        </form>
    </div>
</div>

